import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { TopActionsWidget } from './top-actions-widget';

@injectable()
export class TopActionsContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        const topPanelNode: HTMLElement | null = document.getElementById('theia-top-panel');
        if (!topPanelNode) return;

        const widget: TopActionsWidget = await this.widgetManager.getOrCreateWidget(TopActionsWidget.ID);
        if (!widget.isAttached) Widget.attach(widget, topPanelNode);
    }
}
